//@ts-nocheck

// Import Swiper
import Swiper, { Navigation, Pagination} from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// Import AOS
import AOS from 'aos'
import 'aos/dist/aos.css'

// Import Bouncer
import * as Bouncer from 'formbouncerjs'

// Import components
import SplitText from './splitText'
import Loader from '../components/loader'

const emails = ['temp-mail.org', 'correotemporal.org', 'mohmal.com', 'yopmail.com', 'tempail.com', 'emailondeck.com', 'emailtemporalgratis.com', 'crazymailing.com', 'tempr.email', 'bupmail.com', 'guerrillamail.com', 'temp-mail.io', 'es.emailfake.com', 'nowmymail.com', '10minutemail.net', 'es.getairmail.com', 'mailf5.com', 'flashmail.it', '10minemail.com', 'mailcatch.com', 'temp-mails.com', 'spambox.us', 'mailnull.com', 'incognitomail.com', 'ssl.trashmail.net', 'trashmail.net', 'mailinator.com', 'tempinbox.com', 'filzmail.com', 'dropmail.me', 'spam4.me', 'cs.email', 'one-off.email', 'throwawaymail.com', 'emailtemporal.org', 'maildrop.cc', 'mailforspam.com', 'trashmail.com', 'teleworm.us', 'superrito.com', 'rhyta.com', 'jourrapide.com', 'gustr.com', 'fleckens.hu', 'einrot.com', 'cuvox.de', 'dayrep.com', 'muyoc.com', 'buxod.com', 'pidox.org', 'mecip.net', 'pudxe.com', 'xedmi.com', 'ludxc.com', 'juzab.com', 'klepf.com', 'matra.site', 'bombamail.icu', 'yermail.net', 'totallynotfake.net', 'techblast.ch', 'spamthis.network', 'spammy.host', 'spammer.fail', 'shadap.org', 'pewpewpewpew.pw', 'netcom.ws', 'itcompu.com', 'disposable.site', 'deinbox.com', 'sharklasers.com', 'guerrillamailblock.com', 'guerrillamail.org', 'guerrillamail.net', 'guerrillamail.de', 'guerrillamail.biz', 'grr.la', 'netmail.tk', 'laste.ml', 'firste.ml', 'zeroe.ml', 'supere.ml', 'emlhub.com', 'emlpro.com', 'emltmp.com', 'yomail.info', '10mail.org', 'wegwerfmail.org', 'wegwerfmail.net', 'wegwerfmail.de', 'trashmail.me', 'trashmail.io', 'trashmail.at', 'trash-mail.at', 'rcpt.at', 'proxymail.eu', 'objectmail.com', 'kurzepost.de', 'damnthespam.com', 'contbay.com', '0box.eu', 'marmaryta.space', '5y5u.com', '58as.com', 'firemailbox.club', 'mozej.com', 'mailna.co', 'mailna.in', 'mailna.me', 'mohmal.im', 'mohmal.in', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf', 'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr', 'courriel.fr.nf', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'nedoz.com', 'nmagazinec.com', 'armyspy.com', 'vmani.com', 'discard.email', 'discardmail.com', 'discardmail.de', 'spambog.com', 'spambog.de', 'spambog.ru', '0btcmail.pw', '815.ru', 'knol-power.nl', 'hartbot.de', 'freundin.ru', 'smashmail.de', 's0ny.net', 'pecinan.net', 'budaya-tionghoa.com', 'lajoska.pe.hu', '1mail.x24hr.com', 'from.onmypc.info', 'now.mefound.com', 'mowgli.jungleheart.com', 'yourspamgoesto.space', 'pecinan.org', 'budayationghoa.com', 'CR.cloudns.asia', 'TLS.cloudns.asia', 'MSFT.cloudns.asia', 'B.cr.cloUdnS.asia', 'ssl.tls.cloudns.ASIA', 'sweetxxx.de', 'DVD.dns-cloud.net', 'DVD.dnsabr.com', 'BD.dns-cloud.net', 'YX.dns-cloud.net', 'SHIT.dns-cloud.net', 'SHIT.dnsabr.com', 'eu.dns-cloud.net', 'eu.dnsabr.com', 'asia.dnsabr.com', '8.dnsabr.com', 'pw.8.dnsabr.com', 'mm.8.dnsabr.com', '23.8.dnsabr.com', 'pecinan.com', 'disposable-email.ml', 'pw.epac.to', 'postheo.de', 'sexy.camdvr.org', 'Disposable.ml', '888.dnS-clouD.NET', 'adult-work.info', 'casinokun.hu', 'bangsat.in', 'wallus.casinokun.hu', 'trap-mail.de', 'umailz.com', 'panchoalts.com', 'gmaile.design', 'ersatzauto.ch', 'tempes.gq', 'cpmail.life', 'tempemail.info', 'coolmailcool.com', 'kittenemail.com', '99email.xyz', 'notmyemail.tech', 'm.cloudns.cl', 'twitter-sign-in.cf', 'anonymized.org', 'you.has.dating', 'ketoblazepro.com', 'kost.party', '0hio0ak.com', '4dentalsolutions.com', 't.woeishyang.com', 'ondemandemail.top', 'kittenemail.xyz', 'blackturtle.xyz', 'y.x.ssl.cloudns.asia', 'geneseeit.com', 'mailg.ml', 'media.motornation.buzz', 'sage.speedfocus.biz', 'badlion.co.uk', 'safeemail.xyz', 'virtual-generations.com', 'new-york.host', 'mrdeeps.ml', 'kitela.work', 'fouadps.cf', 'megacorp.work', 'fake-wegwerf.email', 'tigytech.com', 'historictheology.com', 'ma.567map.xyz', 'hotmailproduct.com', 'maxsize.online', 'happyfreshdrink.com', 'denomla.com', 'pansamantala.poistaa.com', 'sahaltastari.sytes.net', 'cecep.ddnsking.com', 'fadilmalik.ddnsking.com', 'csingi.sytes.net', 'richmail.ga', 'tikmail.gq', 'bupkiss.ml', 'guerrillamail.info', 'pokemail.net', 'myinbox.icu', 'just4fun.me', 'inscriptio.in', 'cloud-mail.top', 'safemail.icu', 'montokop.pw', 'tempamailbox.info', 'blogtron.com', 'atanetorg.org', 'aristockphoto.com', 'jomcs.com', 'kukuka.org', 'gothill.com', 'mixely.com', 'marsoasis.org', 'walmarteshop.com', 'outlandlabs.com', 'comectrix.com', 'buymondo.com', 'eventao.com', 'louieliu.com', 'mymailnow.xyz', 'cuoly.com', 'getnada.com', 'abyssmail.com', 'boximail.com', 'clrmail.com', 'dropjar.com', 'getairmail.com', 'givmail.com', 'inboxbear.com', 'robot-mail.com', 'tafmail.com', 'vomoto.com', 'zetmail.com']


export const page = async () => {
    if (window.scrollY >= 500) {
        window.scrollTo(0, 0)
    }

    window.onload = function () {
        initialize()
        new Loader()
    }
    window.addEventListener('load', validarTamañoPantalla);
    window.addEventListener('resize', validarTamañoPantalla);
}

function initialize() {
    modalToggle()
    setupSplits()
    toggleFAQ()
    setSwiper()
    scollToTop()
    validateFormRegister()
    openModalOk()
    closeModalOk()
    validateFormDB()
    openModalVideo()

    //AOS
    AOS.init({
        once: true,
    })

    if(window.location.search == '') {
        localStorage.removeItem('formCity')
    }
}

function validateFormDB() {
    const modal = document.querySelector('.modalRegistro[data-modal="registro"]')
    const formRegistro = modal.querySelector('.register-form')
    const errorRegistro = formRegistro.querySelector('.error-drupal')

    if(errorRegistro) {
        modal.classList.remove('is-close')
    }
}

function openModalOk() {
    const id = new URL(location).searchParams.get('uid')

    if(id) {
        const modal = document.querySelector('.modalRegistro[data-modal="registro"]')
        const modalOk = document.querySelector('.modalOk[data-modal="registro-ok"]')
    
        if (modal && id) {
            modal.classList.add('is-close')
            modalOk.classList.remove('is-close')
    
            fetch(`/user/data/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(response => response.json())
            .then((json) => {
                const button = modalOk.querySelector('.buttonMeals')
                const buttonHref = button.getAttribute('href')
                const close = modalOk.querySelector('.modalOk-close')
                const closeHref = close.getAttribute('data-href')
                const title = document.querySelector('.registroOk__title')
                const name = json.data.name.split(' ')[0]
                title.innerHTML = ''    
                
                title.innerHTML = `EN HORA BUENA,`
                button.setAttribute('href', `${buttonHref}?uid=${id}`)
                close.setAttribute('data-href', `${closeHref}${id}`)
            })
            .catch((err: any) => {
                console.log(err)
            });
        }
    }
}

function closeModalOk() {
    const modalOk = document.querySelector('.modalOk[data-modal="registro-ok"]')

    if(modalOk) {
        setTimeout(()=> {
            const modalClose = modalOk.querySelector('.modalOk-close')
            const hrefModal = modalClose ? modalClose.getAttribute('data-href') : ''
            if(modalClose) {
                modalClose.addEventListener('click', () => {
                    const hrefModalSplit = hrefModal.split('?')
                    window.location = `${window.location.origin}${hrefModalSplit[0]}?${hrefModalSplit[1]}`
                })
            }
        }, 3000)
    }
}

function validateFormRegister() {
    const emailInput = document.querySelector('#edit-email')
    emailInput.addEventListener('keyup', () => {
        const messageEmail = document.querySelector('#error-drupal-email')
            
        if (messageEmail) {
            messageEmail.style.display = 'none'
        }
    })

    const phoneInput = document.querySelector('#edit-phone')
    phoneInput.addEventListener('keyup', () => {
        const messagePhone = document.querySelector('#error-drupal-phone')
            
        if (messagePhone) {
            messagePhone.style.display = 'none'
        }
    })

    document.addEventListener('bouncerShowError', function (event) {
        if(event.target.name == 'phone') {
            const messagePhone = document.querySelector('#error-drupal-phone')
            
            if (messagePhone) {
                messagePhone.style.display = 'none'
            }
        }
        
        else if(event.target.name == 'email') {
            const messageEmail = document.querySelector('#error-drupal-email')

            if (messageEmail) {
                messageEmail.style.display = 'none'
            }
        }
    }, false);

    document.addEventListener('bouncerFormValid', function (event) {
        const city = document.querySelector('#edit-city_tid').value
        localStorage.setItem('formCity', city);
    }, false);

    var validate = new Bouncer('#register-form', {
        patterns: {
            email: /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find(m => m === array_email[1]);
                return res === undefined ? false : true;
            },

            dateFebruary : function (field:any){
                if (field.name == 'month') {
                    let inputDay = document.querySelector("#edit-day")
                    let inputMonth = document.querySelector("#edit-month")
                    if(inputMonth.value == '02'){
                        if(inputDay.value == '30' || inputDay.value == '31'){
                            return true;
                        }
                    }
                }                
            },

            phoneVerified: function (field: any) {
                if (field.name == 'phone') {
                    const value = field.value
                    if (value.length < 7 || value.length > 10) {
                        return true;
                    }
                }
            },
            ageVerified: function(field: any) {
                if (field.name === 'year') { 
                    const actualDate = new Date();
                    const yearActual = parseInt(actualDate.getFullYear());
                    const monthActual = parseInt(actualDate.getMonth()) + 1;
                    const dayActual = parseInt(actualDate.getDate());

                    let year = document.getElementById('edit-year') as any 
                    let month = document.getElementById('edit-month') as any
                    let day = document.getElementById('edit-day') as any
                    year = year.value;
                    month = month.value;
                    day = day.value;

                    let age = yearActual - year;
                    if(monthActual < month){
                        age--
                    }else if(monthActual == month){
                        if(dayActual < day){
                            age--
                        }
                    }
                    if(age < 18){
                        return true;
                    }
                }
            },
            onlyLetter: (field: any) => {
                if (field.name == 'name' || field.name == 'lastname') {
                    const value = field.value;
                    const pattern = new RegExp(
                        "^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+$",
                        "i"
                    );
                    if (!pattern.test(value)) return true;
                }
            },

            onlyNumbers: (field: any) => {
                if (field.name == 'phone') {
                    const value = field.value;
                    const pattern = new RegExp(
                        "^[0-9]+$"
                    );
                    if (!pattern.test(value)) return true;
                }
            }
        },
        messages: {
            missingValue: {
              checkbox: (e) => {
                if (e.name == 'terms') {
                    return 'Debe aceptar Términos y condiciones'
                }

                else if (e.name == 'privacy'){
                    return 'Debe aceptar Políticas de privacidad'
                }
              },
              default: 'Campo Obligatorio'
            },
            emailVerified: 'Ingresa un correo electrónico válido',
            phoneVerified: 'Ingresa un número de teléfono válido',
            onlyLetter: 'Ingresa solo letras',
            onlyNumbers: 'Ingresa solo números',
            ageVerified: 'Debes ser mayor de edad',
            dateFebruary: 'Fecha invalida',
            patternMismatch: {
                email: 'Por favor ingrese un email válido'
            },
        },
    });
}
function openModalVideo() {  
    const btn = document.querySelector('.buttonVideo')
    if (btn) {
        const idModal = btn.getAttribute('data-modal')
        const modal = document.querySelector(`.modalVideo[data-modal="${idModal}"]`)
        btn.addEventListener('click', () => {            
            modal?.classList.add('modalVideo__active')
            const video = modal.querySelector('.modalVideo__iframe iframe')
            if(video) {
                setTimeout(() => {
                    video?.setAttribute('src', video.src + '?enablejsapi&autoplay=1')                    
                }, 200);
            }
            closeModal()
        })
    }
}
function closeModal() {
    const modal = document.querySelectorAll('.modalVideo__active, .modalRegistro-close');
    modal.forEach(element => {
      element.addEventListener('click', (e) => {
        const targetElement = e.target;
        const btnClose = element.parentElement?.parentElement;        
        targetElement.classList.remove('modalVideo__active');
        btnClose?.classList.remove('modalVideo__active');
        const autoplay = document.querySelector('.modalVideo__iframe iframe').getAttribute('src')
        const removeAutoplay = autoplay.replace("?enablejsapi&autoplay=1", "");
        document.querySelector('.modalVideo__iframe iframe').setAttribute('src', removeAutoplay)
      });
    });
  }
function scollToTop() {
    const btnScroll = document.querySelector('.faqsMeals__top')

    if (btnScroll) {
        btnScroll.addEventListener('click', () => {
            scrollTo(0,0)
        })
    }
}

function setSwiper() {
    const swiperBanner = new Swiper('.swiperMeals', {
        modules: [Navigation,Pagination],
        spaceBetween: 0,
        speed: 1000,
        direction: 'horizontal',
        centeredSlides: true,
        loop: false,
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}
function validarTamañoPantalla() {
    var ancho = window.innerWidth;
    if (ancho < 768) {
        setParticiparSwiper()
    }
    
}
function setParticiparSwiper() {
    const swiperBanner = new Swiper('.participar__pasos', {
        modules: [Navigation,Pagination],
        spaceBetween: 20,
        speed: 1000,
        direction: 'horizontal',
        centeredSlides: true,
        loop: false,
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}
function modalToggle() {
    const openModalButton = document.querySelectorAll('.open-modal');

    if (openModalButton) {
        openModalButton.forEach((element) => {
            const idModal = element.getAttribute('data-modal')
            const modal = document.querySelector(`.modalRegistro[data-modal="${idModal}"]`)
            
            if (modal) {
                const close = modal.querySelector('.modalRegistro-close');
                const videos = modal.querySelectorAll('iframe');
                
                element.addEventListener('click', function () {
                    if (modal) {
                        modal.classList.remove('is-close')
                        new SplitText('.registro__title')
                        new SplitText('.registro__text p')
                    }
                })
        
                if (modal && close) {
                    close.addEventListener("click", function () {
                        modal.classList.add("is-close");
        
                        if (videos) {
                            videos.forEach((video) => {
                                const videoSrc = video.src;
                                video.src = videoSrc
                            })
                        }
                    })
                }
            }
        })
    }
}

function toggleFAQ() {
    const questions = document.querySelectorAll('.block')
    
    questions.forEach(element => {
        const btn = element.querySelector('.block__question')

        if (btn) {
            btn.addEventListener('click', function () {
                questions.forEach(i => i.classList.remove('active'))
                element.classList.add('active')
            })
        }
    })
}

function setupSplits() {
    new SplitText('.banner__text-h2 h2')
    new SplitText('.banner__text-p .is-bold')
    new SplitText('.banner__text-p .is-medium')
    new SplitText('.participar__title')
    new SplitText('.participar__flex-text .h2')
    new SplitText('.participar__flex-text .parag p')
    new SplitText('.faqsMeals__title')
    new SplitText('.block__question-text-nb')
    new SplitText('.block__question-text-qs')
}
